import { ReactElement, useContext } from "react";
import { CurrentExerciseContext } from "src/providers/CurrentExerciseProvider";

export function CurrentMotions(): ReactElement {
  const { current } = useContext(CurrentExerciseContext);

  return (
    <div>
      <h4>Motions:</h4>
      {current.motions.map((motionObject: any) => {
        return (
          <div>
            <p>
              {motionObject.motion}: {motionObject.explanation}{" "}
            </p>
            <p></p>
          </div>
        );
      })}
    </div>
  );
}
